// extracted by mini-css-extract-plugin
export var formPart = "Subscribe-module--formPart--246fa";
export var imageBlock = "Subscribe-module--imageBlock--f6fd7";
export var leftPart = "Subscribe-module--leftPart--c6952";
export var logoBlock = "Subscribe-module--logoBlock--fac14";
export var mainPart = "Subscribe-module--mainPart--db699";
export var rightContentBlock = "Subscribe-module--rightContentBlock--f20a7";
export var rightPart = "Subscribe-module--rightPart--4d8f0";
export var rightUnderPart = "Subscribe-module--rightUnderPart--557c4";
export var submittedText = "Subscribe-module--submittedText--d1cef";